/**
 * 거래처 전용 화면에서 품명(itemName) 기준으로 행을 필터링합니다.
 * 관리자 페이지에서 설정한 itemNameFilterType, itemNameList에 따라 적용됩니다.
 */

export type ItemNameFilterType = 'all' | 'allow' | 'block';

function normalizeItemName(value: unknown): string {
  if (value === null || value === undefined) return '품명 없음';
  const s = String(value).trim();
  return s === '' ? '품명 없음' : s;
}

/**
 * @param rows 원본 행 배열 (각 행에 itemName 필드 있음)
 * @param type 'all' = 모두 보이게, 'allow' = 목록에 있는 품명만, 'block' = 목록에 있는 품명 제외
 * @param list 품명 문자열 배열 (allow일 때 빈 배열이면 "모두 보이지 않게" = 0건)
 */
export function applyItemNameFilter<T extends { itemName?: unknown }>(
  rows: T[],
  type: ItemNameFilterType,
  list: string[]
): T[] {
  if (!rows || !Array.isArray(rows)) return [];
  if (type === 'all') return rows;

  const set = new Set(list.map(s => s.trim()).filter(Boolean));

  if (type === 'allow') {
    if (set.size === 0) return []; // "모두 보이지 않게"
    return rows.filter(row => set.has(normalizeItemName(row.itemName)));
  }

  if (type === 'block') {
    if (set.size === 0) return rows; // 제외 목록 없음 = 모두 보이게
    return rows.filter(row => !set.has(normalizeItemName(row.itemName)));
  }

  return rows;
}
